import { render } from "./TramitesAvancesAM.vue?vue&type=template&id=b632fcfc&scoped=true"
import script from "./TramitesAvancesAM.vue?vue&type=script&lang=js"
export * from "./TramitesAvancesAM.vue?vue&type=script&lang=js"

import "./TramitesAvancesAM.vue?vue&type=style&index=0&id=b632fcfc&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b632fcfc"]])

export default __exports__